module.exports = __webpack_public_path__ + "static/internal-2f6992d4e0ffc504ae245913096a22d9.jpg";